import { MetaInfo } from "@/components/meta-info"
import { PlanPill } from "@/screens/settings/plan-pill"
import { SettingsHeader } from "../settings-header"
import { OfficeHoursSection } from "./office-hours-settings-page"
import { SlaSection } from "./sla-settings-page"

export function OfficeHoursSlaSettingsPage() {
	return (
		<>
			<MetaInfo title="Office hours & SLAs" />

			<SettingsHeader
				title="Office hours & SLAs"
				subtitle="Configure your team's availability and set response time targets for support threads."
			/>

			<OfficeHoursSection />

			<div className="mb-3 mt-10 flex items-center gap-2">
				<span className="text-sm font-medium text-primary">SLAs</span>
				<PlanPill plan="scale" />
			</div>

			<SlaSection />
		</>
	)
}
